var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',{on:{"click":_vm.openNotification}},[_c('v-list-item-content',[_c('p',{staticClass:"content-msg",domProps:{"innerHTML":_vm._s(_vm.notificationMsg(_vm.item.verb))}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }